import {
  Component, ViewEncapsulation, ChangeDetectionStrategy, Input, ChangeDetectorRef, EventEmitter, Output
} from '@angular/core';

import { isNullOrUndefined } from '@app/util/util';
import { environment } from '@environment';
import { DomManipulateService } from '@app/modules/core/services/dom-manipulate.service';
import { FlightCabin, FlightDetailCabinPayload } from '@shared/flight-itinerary/entities/cabin-types';
import { FlightAmenitie } from '@app/entities/flight-results';
import { LoaderRingType } from '@design-system/components/atoms/loader-ring/entities/loader-ring.types';
import { Icon, IconFillColor } from '@design-system/components/atoms/icon/entities/icon.types';
import { TypographyColor, TypographyFontSize } from '@design-system/components/atoms/typography/entities/typography.types';

@Component({
  selector: 'app-itinerary-cabin',
  templateUrl: './itinerary-cabin.component.html',
  styleUrls: ['./itinerary-cabin.component.sass'],
  encapsulation: ViewEncapsulation.ShadowDom,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class ItineraryCabinComponent {

  @Input() sector: number;
  @Input() airplane: string;
  @Input() airlineCode: string;
  @Input() airlineName: string;
  @Input() number: number;
  @Input() departureAirport: string;
  @Input() arrivalAirport: string;
  @Input() departureDate: string;
  @Input() cabin: string;
  @Input() cabinAmenities: FlightAmenitie;
  @Input() isLoggedIn: boolean;
  @Input() isLoadingFlightCabin: boolean;
  @Input() flightCabinSelected: FlightCabin;
  @Input() isMobile: boolean = true;

  @Output() openCabinDetail: EventEmitter<FlightDetailCabinPayload> = new EventEmitter<FlightDetailCabinPayload>();

  public show: boolean = false;

  public readonly loaderRingType = LoaderRingType.Secondary;
  
  public readonly iconChevronRight = Icon.ChevronRight;

  public readonly iconWifi = Icon.Wifi;
  public readonly iconInFlightEntertainment = Icon.InFlightEntertainment;
  public readonly iconPower = Icon.Power;

  public readonly iconFillColor = IconFillColor;

  public readonly typographySizeXXS = TypographyFontSize.XXS;
  public readonly typographySizeXXXS = TypographyFontSize.XXXS;

  public readonly primaryTextColor = TypographyColor.Primary;
  public readonly secondaryTextColor = TypographyColor.Secondary;

  constructor(
    private changeDetector: ChangeDetectorRef,
    private domManipulateService: DomManipulateService
  ) { }

  get isAvailable(): boolean {
    return !!this.airplane;
  }

  get isLoadedWithResult(): boolean {
    return !this.isLoadingFlightCabin && !isNullOrUndefined(this.flightCabinSelected);
  }

  public openCabinDetailClicked(): void {
    this.show = true;
    this.domManipulateService.setBodyScroll(false);
    this.openCabinDetail.emit({
      AirlineCode: this.airlineCode,
      Equipment: this.airplane,
      FlightNumber: this.number,
      DepartureAirport: this.departureAirport,
      ArrivalAirport: this.arrivalAirport,
      DepartureDateTime: this.departureDate,
      CabinType: this.cabin,
      Language: environment.language
    });
    this.changeDetector.detectChanges();
  }

  public closeCabinDetail(): void {
    this.show = !this.show;
  }

}
